// mirrorUtils.ts
const queue: (() => void)[] = [];
let activeRequests = 0;
const MAX_REQUESTS_PER_SECOND = 50;
const INTERVAL = 1000 / MAX_REQUESTS_PER_SECOND;

// Simple rate limiter
const processQueue = () => {
  if (queue.length === 0 || activeRequests >= MAX_REQUESTS_PER_SECOND) return;

  const fn = queue.shift();
  if (fn) {
    activeRequests++;
    fn();
    setTimeout(() => {
      activeRequests--;
      processQueue();
    }, INTERVAL);
  }
};

export const limitedFetch = (input: RequestInfo, init?: RequestInit): Promise<Response> =>
  new Promise((resolve, reject) => {
    queue.push(() => {
      fetch(input, init).then(resolve).catch(reject);
    });
    processQueue();
  });

// Fetch all tokens with pagination
export const getAllAssociatedTokens = async (accountId: string): Promise<any[]> => {
  let tokens: any[] = [];
  let nextLink: string | null = `https://mainnet.mirrornode.hedera.com/api/v1/accounts/${accountId}/tokens?limit=100`;

  while (nextLink) {
    //const res = await limitedFetch(nextLink);
    const res: Response = await limitedFetch(nextLink);

    const data = await res.json();
    tokens = tokens.concat(data.tokens || []);
    nextLink = data.links?.next
      ? `https://mainnet.mirrornode.hedera.com${data.links.next}`
      : null;
  }

  return tokens;
};

// Check token association
export const isAssociatedWithToken = async (accountId: string, tokenId: string): Promise<boolean> => {
  const tokens = await getAllAssociatedTokens(accountId);
  return tokens.some((t: any) => t.token_id === tokenId);
};

// Get token balance
export const getTokenBalance = async (accountId: string, tokenId: string): Promise<number> => {
  const tokens = await getAllAssociatedTokens(accountId);
  const token = tokens.find((t: any) => t.token_id === tokenId);
  return token ? parseInt(token.balance) : 0;
};
